<script lang="ts" setup>
import type { ChatMessageSendingJobForm_MessageText } from '../types'
import DolphinTextarea from '@/components/atoms/DolphinTextarea.vue'
import MessageAttachmentActions from '@/components/organisms/MessageAttachmentActions/MessageAttachmentActions.vue'
import { computed } from 'vue'

const model = defineModel<ChatMessageSendingJobForm_MessageText>({
  required: true,
})

const selections = computed({
  get: () => {
    return model.value.selections ?? []
  },
  set: newValue => {
    if (newValue.length === 0) {
      model.value.selections = undefined
    } else {
      model.value.selections = newValue
    }
  },
})
</script>

<template>
  <section>
    <DolphinTextarea
      v-model="model.text"
      :rows="8"
      cols="120"
      :class="$style.message"
    />
    <MessageAttachmentActions v-model="selections" :class="$style.selections" />
  </section>
</template>

<style lang="scss" module>
.message {
  border: 1px solid $color-border-low-emphasis;
}

.selections {
  margin-top: 16px;
}
</style>
